<template>
  <b-container fluid class="bg-white">
    <div class="row align-items-center mb-3 timesheet-toolbar" v-if="!showPrompt">
      <div class="col-lg-5">
        <treeselect
          class="project-select"
          placeholder="Add a project to your timesheet..."
          v-model="newProjectSettings.val"
          :multiple="newProjectSettings.multiple"
          :clearable="newProjectSettings.clearable"
          :searchable="newProjectSettings.searchable"
          :open-on-click="newProjectSettings.openOnClick"
          :close-on-select="newProjectSettings.closeOnSelect"
          :limit="newProjectSettings.limit"
          :options="newProjectSettings.options"
        />
      </div>
      <div class="col-lg-3 mt-2 mt-lg-0">
        <b-button
          variant="outline-primary"
          size="sm"
          class="copy-week-btn px-3 py-2"
          :disabled="loading"
          @click="copyLastWeek()"
        >
          <b-icon icon="files" class="mr-1"></b-icon>
          Copy last week
        </b-button>
      </div>
      <div class="col-lg-4 text-lg-right mt-2 mt-lg-0">
        <span
          v-if="calendarItems.length"
          class="tbl-save-status"
          :class="saveStatus.class"
        >
          <b-spinner
            v-if="saveStatus.spinner"
            small
            class="tbl-save-spinner"
          ></b-spinner>
          <b-icon
            v-else-if="saveStatus.icon"
            :icon="saveStatus.icon"
            class="mr-1"
          ></b-icon>
          {{ saveStatus.text }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 timesheet-table-wrap">
        <b-table
          fixed
          small
          responsive
          borderless
          striped
          thead-class="tbl-header"
          tbody-class="tbl-body"
          :fields="calendarFields"
          :items="calendarItems"
        >
          <template #cell(project)="data">
            <div
              class="tbl-project-holder"
              :style="{
                'background-color': data.item.projectColor
              }"
            >
              <b-icon
                icon="x-circle-fill"
                class="tbl-remove-icon"
                title="Remove Project"
                @click="removeProject(data.item.puid)"
              ></b-icon>
              <span v-b-popover.hover.bottom="data.item.project">
                {{ data.item.project }}
              </span>
            </div>
          </template>
          <template #cell(day_1)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_1.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_1.hours"
              v-if="isNotPassed(data.item.day_1.date)"
              @change="updateTimelog(data.item, 'day_1')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_2)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_2.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_2.hours"
              v-if="isNotPassed(data.item.day_2.date)"
              @change="updateTimelog(data.item, 'day_2')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_3)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_3.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_3.hours"
              v-if="isNotPassed(data.item.day_3.date)"
              @change="updateTimelog(data.item, 'day_3')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_4)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_4.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_4.hours"
              v-if="isNotPassed(data.item.day_4.date)"
              @change="updateTimelog(data.item, 'day_4')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_5)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_5.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_5.hours"
              v-if="isNotPassed(data.item.day_5.date)"
              @change="updateTimelog(data.item, 'day_5')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_8)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_8.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_8.hours"
              v-if="isNotPassed(data.item.day_8.date)"
              @change="updateTimelog(data.item, 'day_8')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_9)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_9.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_9.hours"
              v-if="isNotPassed(data.item.day_9.date)"
              @change="updateTimelog(data.item, 'day_9')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_10)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_10.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_10.hours"
              v-if="isNotPassed(data.item.day_10.date)"
              @change="updateTimelog(data.item, 'day_10')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_11)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_11.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_11.hours"
              v-if="isNotPassed(data.item.day_11.date)"
              @change="updateTimelog(data.item, 'day_11')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
          <template #cell(day_12)="data">
            <b-form-input
              class="tbl-body-block-timelog"
              type="number"
              placeholder="-"
              min="0"
              max="24"
              :class="{
                'tbl-input-zero-val': data.item.day_12.hours === 0
              }"
              :disabled="loading"
              v-model="data.item.day_12.hours"
              v-if="isNotPassed(data.item.day_12.date)"
              @change="updateTimelog(data.item, 'day_12')"
            />
            <span v-else class="tbl-future-cell" title="Upcoming day">-</span>
          </template>
        </b-table>
        <b-overlay
          :show="showPrompt"
          no-wrap
          @shown="onShown"
          @hidden="onHidden"
        >
          <template #overlay>
            <div
              v-if="loading"
              class="text-center p-4 bg-primary text-light rounded"
            >
              <div class="mb-3">Please wait...</div>
            </div>
            <div
              v-else
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="text-center p-3"
            >
              <h6>
                <strong
                  >Are you sure you want to remove this project and its timelogs
                  from the selected weeks?</strong
                >
              </h6>
              <div class="text-center">
                <b-button
                  variant="outline-danger"
                  class="mr-3"
                  @click="onCancel"
                >
                  Cancel
                </b-button>
                <b-button variant="outline-success" @click="onOK">OK</b-button>
              </div>
            </div>
          </template>
        </b-overlay>
      </div>
    </div>
  </b-container>
</template>

<script>
import {
  addDays,
  format,
  isToday,
  isWeekend,
  isBefore,
  isSameDay,
  getDay
} from 'date-fns'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.min.css'

export default {
  name: 'TwoWeeksCalendarTimelog',
  components: {
    Treeselect
  },
  props: {
    showWeekends: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    projects: {
      type: Array,
      default: () => []
    },
    timelogs: {
      type: Array,
      default: () => []
    },
    _fn_runTimelogQueue: {
      type: Function,
      default: () => {}
    },
    _fn_getPreviousWeekTimelogs: {
      type: Function,
      default: () => []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    calendarWeeksStartDate() {
      return this.Store.calendarWeeksStartDate
    },
    calendarFields() {
      return this.Store.timelogCalendarFields
    },
    logsInQueue() {
      return this.Store.timelogsInQueue
    },
    saveStatus() {
      if (this.loading) {
        return { text: 'Saving...', class: 'is-saving', spinner: true, icon: null }
      }
      const pending = this.logsInQueue.length
      if (pending) {
        return {
          text: `${pending} unsaved change${pending > 1 ? 's' : ''}`,
          class: 'is-pending',
          spinner: false,
          icon: 'pencil'
        }
      }
      return {
        text: 'All changes saved',
        class: 'is-saved',
        spinner: false,
        icon: 'check2'
      }
    },
  },
  data() {
    return {
      weeks: {
        defaultDates: []
      },
      calendarItems: [],
      newProjectSettings: {
        value: null,
        multiple: false,
        clearable: true,
        searchable: true,
        openOnClick: true,
        closeOnSelect: true,
        limit: 1,
        options: []
      },
      showPrompt: false,
      projectToRemove: null
    }
  },
  watch: {
    calendarWeeksStartDate: {
      handler: 'weekChangeHandler',
      deep: true,
      immediate: true
    },
    projects() {
      this.importTimelogs()
    },
    timelogs() {
      this.importTimelogs()
    },
    'newProjectSettings.val': {
      handler(val) {
        return this.selectNewProject(val)
      },
      deep: true
    }
  },
  methods: {
    weekChangeHandler() {
      console.log('WEEK CHANGE HANDLER!')
      this.weeks.defaultDates = this.setDefaultDates()
        // Generate Calendar
        let dayIndex = 0
        this.$store.commit('setTimelogCalendarFields', [
          {
            key: 'project',
            label: 'Project',
            thClass: 'tbl-header-team',
            tdClass: 'tbl-body-team'
          },
          ...this.weeks.defaultDates.map((date) => {
            dayIndex++
            return {
              key: `day_${dayIndex}`,
              // label: `DAY ${dayIndex}`,
              label: this.formatHeaderDate(date),
              thClass: {
                'tbl-header-day-holder': true,
                today: this.isToday(date),
                weekend: this.isWeekend(date)
              },
              tdClass: {
                'tbl-body-block': true,
                today: this.isToday(date),
                weekend: this.isWeekend(date)
              }
            }
          })
        ])
        setTimeout(this.importTimelogs, 500)
    },
    selectNewProject(puid) {
      if (!puid) return
      const selectedProject = this.newProjectSettings.options.find(
        (prj) => prj.id === puid
      )
      // check if already exists
      const itemExists = this.calendarItems.find(
        (itm) => itm.puid === selectedProject.id
      )
      if (itemExists) {
        this.$bvToast.toast('Project already exists', {
          title: 'Notice',
          variant: 'warning',
          solid: true
        })
        return
      }
      this.calendarItems.push({
        puid: selectedProject.id,
        project: selectedProject.project,
        projectColor: selectedProject.color
      })
      let startDate = null
      this.calendarFields.forEach((field) => {
        if (!/^day_/.test(field.key)) return
        if (!startDate) {
          startDate = this.calendarWeeksStartDate
        } else {
          startDate = addDays(new Date(startDate), 1)
        }
        if (this.isWeekend(startDate)) return
        this.calendarItems[this.calendarItems.length - 1][field.key] = {
          date: startDate,
          hours: ''
        }
      })
      this.sortCalendarItems()
      this.newProjectSettings.val = null
    },
    setDefaultDates() {
      return new Array(14)
        .fill(0)
        .map((_, i) =>
          format(addDays(this.calendarWeeksStartDate, i), 'yyyy-MM-dd')
        )
        .filter((_, i) => this.showWeekends || i % 7 < 5)
    },
    isToday(date) {
      return isToday(new Date(date))
    },
    isWeekend(date) {
      return isWeekend(new Date(date))
    },
    isNotPassed(date) {
      return isBefore(new Date(date), new Date())
    },
    formatHeaderDate(date, cformat = 'EEE do') {
      return format(new Date(date), cformat)
    },
    importTimelogs() {
      if (!this.calendarFields || !this.calendarFields.length) return
      const grouped = this.timelogs.reduce((acc, itm) => {
        acc[itm.project.uid] = acc[itm.project.uid] || []
        acc[itm.project.uid].push(itm)
        return acc
      }, {})
      const availableProjectsToSelect = [...this.projects]
        .filter((itm) => !grouped[itm.uid])
        .reduce((acc, itm) => {
          acc[itm.uid] = {
            id: itm.uid,
            puid: itm.uid,
            label: itm.title,
            project: itm.title,
            color: itm.meta.color
          }
          return acc
        }, {})
      this.newProjectSettings.options = Object.values(availableProjectsToSelect)

      this.calendarItems = new Array(Object.keys(grouped).length)
        .fill({})
        .map((_, idx) => {
          return {
            puid: Object.values(grouped)[idx][0].project.uid,
            project: Object.values(grouped)[idx][0].project.title,
            projectColor: Object.values(grouped)[idx][0].project.meta.color
          }
        })
      this.sortCalendarItems()

      let startDate = null
      this.calendarFields.forEach((field) => {
        if (!/^day_/.test(field.key)) return
        if (!startDate) {
          startDate = this.calendarWeeksStartDate
        } else {
          startDate = addDays(new Date(startDate), 1)
        }
        if (this.isWeekend(startDate)) return
        this.calendarItems.forEach((itm) => {
          itm[field.key] = {
            date: startDate,
            hours: ''
          }
        })
      })
      const dayIndexReg = /^day_(\d+)$/
      this.timelogs.forEach((log) => {
        const projectIndex = this.calendarItems.findIndex(
          (itm) => itm.project === log.project.title
        )
        for (const key in this.calendarItems[projectIndex]) {
          if (
            dayIndexReg.test(key) &&
            isSameDay(
              new Date(this.calendarItems[projectIndex][key].date),
              new Date(log.date)
            )
          ) {
            this.calendarItems[projectIndex][key].hours = log.hours || ''
          }
        }
      })
    },
    updateTimelog(item, dateId) {
      if (!this.isNotPassed(item[dateId].date)) return
      const hours = parseFloat(item[dateId]?.hours) || 0
      this.$store.commit('timelogToQueue', {
        project: item.puid,
        date: format(item[dateId].date, 'yyyy-MM-dd'),
        hours
      })
      // A zero value reads back as an empty cell so it shows the "-" placeholder
      if (!hours) {
        item[dateId].hours = ''
      }
    },
    async copyLastWeek() {
      const prevLogs = await this._fn_getPreviousWeekTimelogs()
      if (!prevLogs || !prevLogs.length) {
        this.$bvToast.toast('No timelogs found for last week', {
          title: 'Notice',
          variant: 'warning',
          solid: true
        })
        return
      }
      let copied = 0
      prevLogs.forEach((log) => {
        const hours = parseFloat(log.hours) || 0
        if (!hours) return
        let item = this.calendarItems.find((itm) => itm.puid === log.project.uid)
        if (!item) {
          item = this.addProjectRow(log.project)
        }
        if (!item) return
        const targetKey = this.findFirstWeekKey(item, getDay(new Date(log.date)))
        if (!targetKey) return
        const cell = item[targetKey]
        if (!cell || !this.isNotPassed(cell.date)) return
        // Non-destructive: only fill cells that are still empty
        if (parseFloat(cell.hours) > 0) return
        cell.hours = hours
        this.updateTimelog(item, targetKey)
        copied++
      })
      this.$bvToast.toast(
        copied
          ? `Copied ${copied} entr${copied > 1 ? 'ies' : 'y'} from last week`
          : 'Nothing to copy. Current week cells are already filled or in the past',
        {
          title: copied ? 'Copied' : 'Notice',
          variant: copied ? 'success' : 'warning',
          solid: true
        }
      )
    },
    addProjectRow(project) {
      const exists = this.calendarItems.find((itm) => itm.puid === project.uid)
      if (exists) return exists
      const row = {
        puid: project.uid,
        project: project.title,
        projectColor: project.meta.color
      }
      let startDate = null
      this.calendarFields.forEach((field) => {
        if (!/^day_/.test(field.key)) return
        if (!startDate) {
          startDate = this.calendarWeeksStartDate
        } else {
          startDate = addDays(new Date(startDate), 1)
        }
        if (this.isWeekend(startDate)) return
        row[field.key] = { date: startDate, hours: '' }
      })
      this.calendarItems.push(row)
      this.sortCalendarItems()
      this.newProjectSettings.options = this.newProjectSettings.options.filter(
        (opt) => opt.id !== project.uid
      )
      return row
    },
    sortCalendarItems() {
      this.calendarItems.sort((a, b) =>
        (a.project || '').localeCompare(b.project || '')
      )
    },
    findFirstWeekKey(item, weekday) {
      for (const key in item) {
        const match = /^day_(\d+)$/.exec(key)
        if (!match || parseInt(match[1], 10) > 7) continue
        if (item[key] && getDay(new Date(item[key].date)) === weekday) {
          return key
        }
      }
      return null
    },
    removeProject(puid = this.projectToRemove, approved = false) {
      if (!approved) {
        this.projectToRemove = puid
        this.showPrompt = true
      } else {
        const item = this.calendarItems.find((itm) => itm.puid === puid)
        for (const key in item) {
          if (item[key].date) {
            this.$store.commit('timelogToRemoveQueue', {
              project: puid,
              date: format(item[key].date, 'yyyy-MM-dd')
            })
          }
        }
        this.calendarItems = this.calendarItems.filter(
          (itm) => itm.puid !== puid
        )
        this.projectToRemove = null
        this.showPrompt = false
      }
    },
    onShown() {
      this.$refs.dialog.focus()
    },
    onHidden() {
      this.$refs.submit.focus()
    },
    onCancel() {
      this.showPrompt = false
      this.projectToRemove = null
    },
    onOK() {
      this.removeProject(this.projectToRemove, true)
    }
  }
}
</script>

<style>
.timesheet-toolbar {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
  padding: 10px 6px;
}
.project-select .vue-treeselect__control {
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  height: 38px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.project-select .vue-treeselect__control:hover {
  border-color: #0073be;
}
.project-select .vue-treeselect__control--focused {
  border-color: #0073be !important;
  box-shadow: 0 0 0 3px rgba(0, 115, 190, 0.15) !important;
}
.vue-treeselect__placeholder {
  color: #94a3b8;
  font-size: 10pt;
  line-height: 36px;
}
.vue-treeselect__single-value {
  font-size: 10pt;
  color: #1e293b;
  line-height: 36px;
}
.timesheet-table-wrap .table-responsive {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
}
.tbl-header {
  background: linear-gradient(135deg, #002d54 0%, #0054aa 100%) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  padding: 0 !important;
  font-weight: 700;
  font-size: 9pt;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  height: 44px;
  line-height: 44px;
  min-width: 100% !important;
  max-width: 100% !important;
}
.tbl-header-team {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-top-left-radius: 8px;
  padding: 0 !important;
  text-align: center;
  font-weight: 800;
  width: 9% !important;
  max-width: 9% !important;
}
.tbl-header-day-holder {
  text-align: center;
  padding: 0 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.08) !important;
  width: 6.5% !important;
  max-width: 6.5% !important;
}
.tbl-header-day-holder.today {
  background-color: #0073be !important;
  font-weight: 800;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);
  padding: 0 !important;
}
.tbl-header-day-holder.weekend {
  background-color: rgba(0, 0, 0, 0.15) !important;
  color: rgba(255, 255, 255, 0.85) !important;
  padding: 0 !important;
}
.tbl-header-day-holder.weekend.today {
  color: #fff !important;
}
.tbl-body {
  background-color: #ffffff;
  min-height: 60px;
  max-height: 60px;
  min-width: 100% !important;
  max-width: 100% !important;
  padding: 0 !important;
}
.tbl-body-team {
  color: #fff;
  background-color: #e2e8f0;
  font-size: 10pt;
  font-weight: 700;
  padding: 0 !important;
  text-align: center;
  height: 60px !important;
  line-height: 60px;
  max-height: 60px !important;
  width: 9% !important;
  max-width: 9% !important;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 2px solid #cbd5e1 !important;
  border-bottom: 1px solid #cbd5e1 !important;
  justify-content: center;
  align-items: center;
}
.tbl-body-block {
  text-align: center;
  padding: 0 !important;
  font-size: 10pt;
  font-weight: bold;
  height: 60px !important;
  line-height: 60px !important;
  max-height: 60px !important;
  width: 6.5% !important;
  max-width: 6.5% !important;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #cbd5e1;
  transition: background-color 0.2s ease;
}
.tbl-body-block:hover {
  background-color: #f1f5f9;
  cursor: default;
  padding: 0 !important;
}
.copy-week-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.2s ease !important;
}
.tbl-save-status {
  display: inline-flex;
  align-items: center;
  font-size: 9pt;
  font-weight: bold;
  text-transform: uppercase;
}
.tbl-save-status.is-saved {
  color: #28a745;
}
.tbl-save-status.is-saving {
  color: #036;
}
.tbl-save-status.is-pending {
  color: #999;
}
.tbl-save-spinner {
  width: 0.85rem;
  height: 0.85rem;
  margin-right: 6px;
}
.tbl-body-block.today,
.tbl-body-block.today .tbl-body-block-timelog,
.tbl-body-block.today .tbl-future-cell {
  background-color: #aed3f0 !important;
  border: none !important;
}
.tbl-body-block.today:hover,
.tbl-body-block.today:hover .tbl-body-block-timelog {
  background-color: #9ec9ea !important;
}
.tbl-body-block.weekend {
  background-color: #e2e8f0 !important;
}
.tbl-body-block.highlighted {
  background-color: rgb(240, 240, 190) !important;
}
.tbl-project-holder {
  position: relative;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
  padding: 4px 22px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 60px;
  overflow: hidden;
}
.tbl-project-holder span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tbl-remove-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
  opacity: 0.6;
}
.tbl-remove-icon:hover {
  opacity: 1;
}
.tbl-body-block-timelog {
  background-color: transparent !important;
  border: none !important;
  text-align: center !important;
  height: 60px !important;
  font-size: 14pt !important;
  font-weight: bold !important;
  color: #6b7280 !important;
}
.tbl-body-block-timelog:focus {
  background-color: rgba(0, 115, 190, 0.12) !important;
  outline-color: transparent !important;
  outline: none !important;
}
.tbl-body-block-timelog.tbl-input-zero-val {
  color: #b0b8c1 !important;
}
.tbl-body-block-timelog::placeholder {
  color: #b0b8c1 !important;
  opacity: 1;
}
.tbl-future-cell {
  display: inline-block;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #cbd5e1;
  font-weight: 600;
  user-select: none;
  cursor: not-allowed;
}
</style>

<style scoped>
.calendar-header {
  background-color: rgb(0, 123, 255);
  padding: 0 !important;
  font-weight: bold;
  font-size: 10pt;
  color: #fff;
  height: 40px;
  line-height: 40px;
  min-width: 100% !important;
  max-width: 100% !important;
}
.calendar-header .team {
  background-color: rgb(177, 177, 177) !important;
  padding: 0 !important;
  text-align: center;
}
.calendar-header .loading {
  background-color: rgb(177, 50, 50) !important;
  color: #fff;
}
.calendar-header .day-holder {
  text-align: center;
  padding: 0 !important;
  width: 7% !important;
  max-width: 7% !important;
}
.calendar-header .day-holder.today {
  background-color: rgb(0, 51, 102) !important;
  padding: 0 !important;
}
.calendar-header .day-holder.weekend {
  background-color: rgb(177, 177, 177) !important;
  padding: 0 !important;
}
.calendar-header .day-holder.weekend.today {
  color: rgb(0, 123, 255) !important;
}
.calendar-body {
  background-color: #eee;
  min-height: 100px;
  max-height: 100px;
  min-width: 100% !important;
  max-width: 100% !important;
  padding: 0 !important;
}
.calendar-body.bgOdd {
  background-color: #f5f5f5 !important;
  padding: 0 !important;
}
.calendar-body .team {
  color: #fff;
  background-color: #333;
  border-top: #999 solid 1px;
  font-size: 10pt;
  font-weight: bold;
  display: inline-block;
  padding: 0 !important;
  text-align: center;
  max-height: 100px !important;
  overflow-y: auto !important;
}
.calendar-body .team ul {
  list-style: none;
  padding: 0 !important;
  margin: 0 5px !important;
}
.calendar-body .team ul li {
  margin: 5px 0;
}
.calendar-body .team ul li .remove-btn {
  font-weight: bold;
  padding: 6px 4px;
}
.calendar-body .team ul li .remove-btn:hover {
  cursor: pointer;
}
.calendar-body .block {
  text-align: center;
  display: block;
  overflow-x: hidden;
  overflow-y: scroll !important;
  padding: 0 !important;
  max-height: 100px !important;
  width: 7% !important;
  max-width: 7% !important;
}
.calendar-body .block.weekend {
  background-color: rgb(190, 190, 190) !important;
}
.calendar-body .block.highlighted {
  background-color: rgb(240, 240, 190) !important;
}
::-webkit-scrollbar {
  width: 0 !important;
}
.calendar-body .block:hover {
  background-color: #ccc;
  cursor: default;
  padding: 0 !important;
}
.calendar-body .block .project {
  margin: 5px;
  padding: 10px;
  font-size: 10pt;
  color: #fff;
  font-weight: bold;
  overflow-wrap: break-word;
  max-width: 100px !important;
}
.calendar-body .block .timelog {
  background-color: transparent;
  border: none;
  text-align: center;
  height: 100px;
  font-size: 12pt;
  font-weight: bold;
  color: #999;
}
.calendar-body .block .timelog:focus {
  color: #333;
}
.addProjectTxt {
  color: #fff;
}
.addProjectTxt:hover {
  color: #fff;
}
.lizard-timelog-project-select {
  width: 80%;
  margin: 0 auto;
}
.lizard-delete-overlay-message {
  font-size: 12pt;
  font-weight: bold;
  color: #333;
}
.lizard-logs-to-remove-list {
  list-style: none;
  margin: 20px 0;
  padding: 0;
}
.lizard-logs-to-remove-list li {
  margin: 0 5px;
  padding: auto;
  font-size: 10pt;
  display: inline-block;
  font-weight: 600;
  color: #666;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
